/*** IMPORTS FROM imports-loader ***/
var define = false;

/*jslint browser: true, todo: true, unparam: true */

"use strict";

// TODO: Extract jquery-dependent code
var ko = require("knockout");
var R = require("ramda");
var Rx = require("rxjs");

var pliObservable = require("../forms-knockoutcontrols");
var pli = require("../forms");
var subscribeWithChanges = require("../knockout/subscribeWithChanges").subscribeWithChanges;

var jQuery = require("../jquery");
var arrayUtil = require("../util/array");
var CompositeDisposable = require("../util/disposable").CompositeDisposable;
var createKnockoutDataProvider = require("../data-provider/knockoutDataProvider").createKnockoutDataProvider;
var QueryOrigin = require("../data-provider/dataProvider").QueryOrigin;


function ensureElementInView(element) {
    if (!element) {
        return;
    }

    if (element instanceof jQuery) {
        element.each(function () {
            ensureElementInView(this);
        });
        return;
    }

    if (typeof element.scrollIntoViewIfNeeded === "function") {
        element.scrollIntoViewIfNeeded(false);
        return;
    }

    var elementRectangle = element.getBoundingClientRect(),
        container = element.parentNode,
        containerRectangle = container.getBoundingClientRect();

    while (elementRectangle.top > containerRectangle.top &&
            elementRectangle.bottom < containerRectangle.bottom &&
            container.parentNode &&
            container.scrollHeight > 0) {
        container = container.parentNode;
        containerRectangle = container.getBoundingClientRect();
    }

    if (container.scrollHeight > 0 &&
            (elementRectangle.top < containerRectangle.top || elementRectangle.bottom > containerRectangle.bottom)) {
        element.scrollIntoView(elementRectangle.top < containerRectangle.top);
    }
}

/**
 * Sets correct group lengths for supplied picklist data.
 *
 * Does not modify original picklist data.
 *
 * @returns
 *     Cloned picklist data with updated group lengths.
 * @this {ko.MaybeObservable<{ data: any, name: string }>}
 */
function transformPicklistData() {
    var picklistData = ko.unwrap(this); // jshint ignore:line

    if (picklistData.data) {

        // clone
        var group, i, j, item, newItems = [],
            data = R.clone(picklistData.data); // deep clone (recursive)

        // clear length of all groups
        for (group in data.groups) {
            if (data.groups.hasOwnProperty(group)) {
                for (i = 0; i < data.groups[group].length; i += 1) {
                    data.groups[group][i].length = 0;
                }
            }
        }

        // transform data items
        for (i = 0; i < data.items.length; i += 1) {
            item = data.items[i];
            // add new item
            newItems.push(item);

            // fix group length
            for (group in data.groups) {
                if (data.groups.hasOwnProperty(group)) {
                    for (j = 0; j < data.groups[group].length; j += 1) {
                        if (item[group] === data.groups[group][j].name) {
                            data.groups[group][j].length += 1;
                        }
                    }
                }
            }

        }

        // set filterd items and indices
        data.items = newItems;

        return { data: data, name: picklistData.name };
    }

    return picklistData;
}

function getDataProvider(o) {
    var d = o.behaviourData;
    if (d) {
        if (typeof d.requestHandler === "function") {
            throw new Error("Multiselect does not support async data");
        }

        var options = {
            displayIndex: o.options.textField,
            searchIndex: o.options.textField,
            itemFilterBuilder: o.options.itemFilterBuilder
        };
        var source = null;

        if (d.subscribe) { // check for the subscribe function instead of ko.isObservable (to handle cross window observables)
            source = d;
        } else if (d.picklistData && d.picklistData.subscribe) {
            source = d.picklistData;
        } else if (d.picklistData.picklistData && d.picklistData.picklistData.subscribe) {
            source = d.picklistData.picklistData;
        }

        if (source) {
            return createKnockoutDataProvider(ko.pureComputed(transformPicklistData, source), options);
        }
    }
    throw new Error("behaviourData or behaviourData.picklistData must contain an observable containing picklist data");
}

//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
// Convenience method to create elements of the multiSelect list
//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~

//-------------------------------------------
function createMultiSelectItem(value, text, categoryValue, isCategory, isError, isSelected, index) {
    return {
        value: value,
        text: text,
        categoryValue: categoryValue,
        isCategory: !!isCategory,
        isError: !!isError,
        isSelected: !!isSelected,
        index: index
    };
}

/**
 * Wrap the function in conditional call to bypass it if the control is disabled or readonly.
 */
function inactiveExecutionGuard(functionToExecute, msVm) {
    if (typeof functionToExecute !== "function") { throw new Error("functionToExecute must be a function"); }
    return function createOnActiveRunner() {
        var isEnabled = msVm.isEnabled();
        if (isEnabled) {
            return functionToExecute.apply(msVm, arguments);
        }
    };
}

//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
// The "MultiSelectViewModel" main viewModel of MultiselectBehaviour
//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~

//-------------------------------------------
function MultiSelectViewModel(items, categories, options, parent) {
    this._options = options || {};

    this.items = items || [];
    this.categories = categories || [];

    this.categoriesAndItems = this.categories.concat(this.items);
    this.selectedItems = ko.observableArray([]); // selected items
    this.currentItem = ko.observable(); // current selected item
    this.currentListItemIndex = ko.observable(-1); // current list item in dropdown list
    this.filter = ko.observable(""); // current filter
    this.isFocused = ko.observable(false); // is focused
    this.isListOpen = ko.observable(false); // shows if dropdown list is open
    this.scrollTop = ko.observable(0); // dropdown scroll top
    this.$container = ko.observable(); // container element
    this.placeholder = null;

    // Dummy observable, used to refresh computed values after update
    // calling _refreshSignaller.notifySubscribers(); does the trick
    this._refreshSignaller = ko.observable();

    //-------------------------------------------
    // computed and subscriptions
    this.allSelectedItems = ko.computed(MultiSelectViewModel.prototype._allSelectedItems, this);
    this.notSelectedItems = ko.computed(MultiSelectViewModel.prototype._notSelectedItems, this);
    this.filteredItems = ko.computed(MultiSelectViewModel.prototype._filteredItems, this);
    this.hasError = ko.computed(MultiSelectViewModel.prototype._hasError, this);
    this.filteredItems.subscribe(MultiSelectViewModel.prototype._filteredItemsUpdateHandler, this);
    this.currentItem.subscribe(MultiSelectViewModel.prototype._scrollToCurrentItem, this);
    this.currentListItemIndex.subscribe(MultiSelectViewModel.prototype.updateScrollTop, this); // updates scrolling position on change current item in dropdown list
    this.isFocused.subscribe(MultiSelectViewModel.prototype._focusedUpdateHandler, this);
    subscribeWithChanges.call(this.selectedItems, MultiSelectViewModel.prototype._selectedItemsUpdateHandler.bind(this));
    this.listSize = ko.computed(MultiSelectViewModel.prototype._listSize, this);
    this.listHeight = ko.computed(MultiSelectViewModel.prototype._listHeight, this);
    this.filter.subscribe(MultiSelectViewModel.prototype._filterUpdateHandler, this);

    // bind this
    this.updateItemsAndCategories = MultiSelectViewModel.prototype.updateItemsAndCategories.bind(this);
    this.unSelectItem = inactiveExecutionGuard(MultiSelectViewModel.prototype.unSelectItem, this);
    this.selectItem = inactiveExecutionGuard(MultiSelectViewModel.prototype.selectItem, this);
    this.isCurrentItem = MultiSelectViewModel.prototype.isCurrentItem.bind(this);
    this.isCurrentListItem = MultiSelectViewModel.prototype.isCurrentListItem.bind(this);
    this.setCurrentItem = inactiveExecutionGuard(MultiSelectViewModel.prototype.setCurrentItem, this);
    this.setCurrentListItem = inactiveExecutionGuard(MultiSelectViewModel.prototype.setCurrentListItem, this);
    this.openList = inactiveExecutionGuard(MultiSelectViewModel.prototype.openList, this);
    this.selectItemsFromDialog = MultiSelectViewModel.prototype.selectItemsFromDialog.bind(this);
    this.focus = inactiveExecutionGuard(MultiSelectViewModel.prototype.focus, this);
    this.removeFocus = MultiSelectViewModel.prototype.removeFocus.bind(this);
    this.showDialog = inactiveExecutionGuard(MultiSelectViewModel.prototype.showDialog, this);
    this.handleKeyUp = inactiveExecutionGuard(MultiSelectViewModel.prototype.handleKeyUp, this);
    this.handleKeyDown = inactiveExecutionGuard(MultiSelectViewModel.prototype.handleKeyDown, this);

    // parent (to handle selected items update)
    if (parent) {

        // set default values from parent observable values (before setting callback to prevent updating parent observable)
        var parentValue = parent.peek();

        if (Array.isArray(parentValue) && parentValue.length) {
            this.setSelectedItemsFromArray(parentValue);
        }

        // set callback function
        if (typeof parent._updateValues === "function") {
            this.callback = parent._updateValues;
        }

        // set data provider
        this.dataProvider = parent._dataProvider;

        // copy reference to parent state
        this.state = parent.state || ko.observable({ isValid: true, isBusy: false, isFailed: false, message: null });

        // close list if state is not valid
        this.state.subscribe(function (newStateValue) {
            if (newStateValue.isFailed || newStateValue.isBusy || !newStateValue.isValid) {
                this.closeList();
            }
        }, this);
    }
}

/**
 * Returns true when this multiselect control is enabled, false otherwise.
 */
MultiSelectViewModel.prototype.isEnabled = function isEnabled() {
    var $container = this.$container();
    return !($container && $container.closest(".pliControl").is(".readOnly, .disabled"));
};

//-------------------------------------------
MultiSelectViewModel.prototype._allSelectedItems = function multiSelectViewModelAllSelectedItems() {
    /// <summary>
    ///     All selected items
    /// </summary>
    this._refreshSignaller(); // add to dependencies of this computed (notifying _refreshSignaller will recompute it)

    return ko.utils.arrayFilter(this.categoriesAndItems, function (item) {
        return !item.isCategory && item.isSelected;
    });
};

//-------------------------------------------
MultiSelectViewModel.prototype._notSelectedItems = function multiSelectViewModelNotSelectedItems() {
    /// <summary>
    ///     Not selected items
    /// </summary>
    this._refreshSignaller(); // add to dependencies of this computed (notifying _refreshSignaller will recompute it)

    return ko.utils.arrayFilter(this.categoriesAndItems, function (item) {
        return !item.isSelected;
    });
};

//-------------------------------------------
MultiSelectViewModel.prototype._filteredItems = function multiSelectViewModelFilteredItems() {
    /// <summary>
    ///     Not-selected items, filtered by text in input element
    /// </summary>
    if (!this.filter() || this.filter().length === 0) {
        return this.notSelectedItems();
    }

    var filter = this.filter().toLowerCase();
    return ko.utils.arrayFilter(this.notSelectedItems(), function (item) {
        return ko.utils.stringStartsWith(item.text.toLowerCase(), filter);
    });
};

 //-------------------------------------------
MultiSelectViewModel.prototype._filteredItemsUpdateHandler = function multiSelectViewModelFilteredItemsUpdateHandler(filteredItems) {
    /// <summary>
    ///     Closes dropdown list if there is no any filtered item left
    /// </summary>

    // if no itmes left in dropdwon list - close it
    if (filteredItems.length === 0) {
        this.closeList();
        return;
    }

    // if current dropdown list item index is in filteredItems
    if (this.currentListItemIndex() > filteredItems.length - 1) {
        this.currentListItemIndex(0);
    }

    // re-open list when there are filtered items
    if (!this.isListOpen() && this.filter() && this.filter().length > 0 && filteredItems.length > 0) {
        this.openList();
    }
};

//-------------------------------------------
MultiSelectViewModel.prototype._focusedUpdateHandler = function multiSelectViewModelFocusedUpdateHandler(newValue) {
    /// <summary>
    ///     When focus on control with error, gets it ready to editing
    /// </summary>
    if (newValue && this.hasError()) {
        var item = this.selectedItems()[this.selectedItems().length - 1],
            errorText = item.text,
            isFirefox = window.InstallTrigger !== undefined;
        this.unSelectItem(item);
        this.filter(errorText);
        // move selection to end of span
        setTimeout(function () {
            var sel, range;
            if (window.getSelection) {
                sel = window.getSelection();
                if (isFirefox) {
                    sel.selectAllChildren(sel.focusNode);
                    sel.collapseToEnd();
                } else {
                    try {
                        sel.collapse(sel.focusNode, errorText.length);
                    } catch (ignore) {}
                }
            } else if (window.document.selection) {
                sel = window.document.selection;
                if (sel.type !== "Control") {
                    range = sel.createRange();
                    range.move("character", errorText.length);
                    range.select();
                }
            }
        }, 0);
    }

    if (newValue) {
        // update position of dropdownlist after focus
        setTimeout(function () {
            this.updateListPosition();
        }.bind(this), this._options.updateDropdownPositionAfterFocusDelay);
    } else {
        // close list and remove selection, uses setTimeout, because list item click event should occur before dropdown closed
        setTimeout(function () {
            // autocomplete
            this.autoComplete();
            // close list
            this.closeListAndUnselect();
        }.bind(this), this._options.closeListDelay);
    }
};

//-------------------------------------------
MultiSelectViewModel.prototype._filterUpdateHandler = function multiSelectViewModelFilterUpdateHandler() {
    /// <summary>
    ///     Ensures dropdownlist position would change accordingly
    /// </summary>
    if (this.isListOpen()) {
        // set delay to allow size of input to be changed first
        setTimeout(function () {
            this.updateListPosition();
        }.bind(this), this._options.updateListPositionAfterFilterTextChangedDelay);
    }
};

//-------------------------------------------
MultiSelectViewModel.prototype._selectedItemsUpdateHandler = function multiSelectViewModelSelectedItemsUpdateHandler(added, deleted) {
    /// <summary>
    ///     Adds/removes categories and ensure parent observable values are changing accordingly
    /// </summary>
    var index,
        categoriesAdded = [],
        categoryItems,
        isAllItemsSelected,
        i;

    if (!this._internalUpdate) {
        // mark items as unselected first
        if (deleted && deleted.length > 0) {
            // remove item from selected and add it to not selected
            ko.utils.arrayForEach(deleted, function (item) {

                // select current element
                index = arrayUtil.binarySearch(item.index, this.categoriesAndItems, "index");
                if (index >= 0) {
                    this.categoriesAndItems[index].isSelected = false;
                }

                if (item.isCategory) {
                    // mark as not-selected all category items
                    categoryItems = this._getItemsByCategory(item);
                    for (i = 0; i < categoryItems.length; i += 1) {
                        index = arrayUtil.binarySearch(categoryItems[i].index, this.categoriesAndItems, "index");
                        if (index >= 0) {
                            this.categoriesAndItems[index].isSelected = false;
                        }
                    }
                }
            }.bind(this));
        }

        if (added && added.length > 0) {
            // add item to selected and remove from not selected
            ko.utils.arrayForEach(added, function (item) {

                // select current element
                index = arrayUtil.binarySearch(item.index, this.categoriesAndItems, "index");
                if (index >= 0) {
                    this.categoriesAndItems[index].isSelected = true;
                }

                // if selected element is category
                if (item.isCategory) {
                    // mark as selected all category items
                    categoryItems = this._getItemsByCategory(item);
                    for (i = 0; i < categoryItems.length; i += 1) {
                        index = arrayUtil.binarySearch(categoryItems[i].index, this.categoriesAndItems, "index");
                        if (index >= 0) {
                            this.categoriesAndItems[index].isSelected = true;
                        }
                    }
                }
            }.bind(this));
        }

        this._refreshSignaller.notifySubscribers(); // refresh data in allSelectedItems and notSelectedItems lists
    }

    // if we have at least one category
    if (this.categories.length > 0) {
        ko.utils.arrayForEach(added, function (item) {
            if (item.isCategory) {
                // if added category - remove all separate items from this category, selected before
                if (this.selectedItems().length > 0) {
                    this._internalUpdate = true;
                    this.selectedItems.remove(function (selectedItem) {
                        return !selectedItem.isCategory && selectedItem.categoryValue === item.value;
                    });
                    this._internalUpdate = false;
                }
            } else {
                // collect unique category values
                if (item.categoryValue) {
                    if (ko.utils.arrayIndexOf(categoriesAdded, item.categoryValue) < 0) {
                        categoriesAdded.push(item.categoryValue);
                    }
                }
            }
        }.bind(this));

        if (categoriesAdded.length > 0) {
            // check if all items of the category is selected
            ko.utils.arrayForEach(categoriesAdded, function (category) {
                var categoryItem = ko.utils.arrayFirst(this.categories, function (cat) {
                    return cat.value === category;
                }.bind(this));

                // if we have such category in the list
                if (categoryItem) {

                    // get items of the categor
                    categoryItems = this._getItemsByCategory(categoryItem);

                    // check if all elements are selected
                    isAllItemsSelected = !(ko.utils.arrayFirst(categoryItems, function (itemOfCategory) {
                        return !(ko.utils.arrayFirst(this.allSelectedItems(), function (selItem) {
                            return itemOfCategory.value === selItem.value;
                        }));
                    }.bind(this)));

                    if (isAllItemsSelected) {
                        // remove all items of the category
                        this.selectedItems.remove(function (selectedItem) {
                            return !selectedItem.isCategory && selectedItem.categoryValue === category;
                        });
                        // add category
                        this.selectedItems.push(categoryItem);
                    }
                }
            }.bind(this));
        }
    }

    // parent obserbale array update
    if (this.callback) {
        this.callback(this.allSelectedItems());
    }
};

//-------------------------------------------
MultiSelectViewModel.prototype._hasError = function multiSelectViewModelHasError() {
    /// <summary>
    ///     Is last selected item has error
    /// </summary>
    this._refreshSignaller(); // add to dependencies of this computed (notifying _refreshSignaller will recompute it)

    return this.selectedItems().length > 0 && this.selectedItems()[this.selectedItems().length - 1].isError;
};

//-------------------------------------------
MultiSelectViewModel.prototype._listSize = function multiSelectViewModelListSize() {
    /// <summary>
    ///     Returns dropdown list size
    /// </summary>
    if (this.filteredItems().length === 0) {
        return 0;
    }
    var size = this.filteredItems().length;
    return size > this._options.maxListSize ? this._options.maxListSize : size;
};

//-------------------------------------------
MultiSelectViewModel.prototype._listHeight = function multiSelectViewModelListHeight() {
    /// <summary>
    ///     Returns height of dropdown list
    /// </summary>
    return this.listSize() * this._options.listItemHeight;
};

//-------------------------------------------
MultiSelectViewModel.prototype._setPlaceholder = function setPlaceholder(placeholder) {
    if (ko.isObservable(placeholder)) {
        this.placeholder = placeholder;
    } else if (typeof placeholder === 'function') {
        this.placeholder = ko.observable(placeholder());
    } else {
        this.placeholder = ko.observable(placeholder);
    }
};

//-------------------------------------------
MultiSelectViewModel.prototype.updateItemsAndCategories = function multiSelectViewModelUpdateItemsAndCategories(items, categories) {
    /// <summary>
    ///     Updates lists of items and categories after picklist data update
    /// </summary>
    this.items = items || [];
    this.categories = categories || [];

    this.categoriesAndItems = this.categories.concat(this.items);

    // notify everything of the changes
    this._refreshSignaller.notifySubscribers();
};

//-------------------------------------------
MultiSelectViewModel.prototype.unSelectItem = function multiSelectViewModelUnSelectItem(element, event) {
    /// <summary>
    ///     Removes element from selected list
    /// </summary>

    // if clicked not left mouse button
    if (event && event.which !== 1) {
        return;
    }

    if (this.isCurrentItem(element)) {
        this.currentItem(null); // clear current item
    }
    this.selectedItems.remove(element);

    // close list
    this.closeList();

    // when click on delete button - do not propagate event
    if (event) {
        event.stopPropagation();
        event.preventDefault();
    }
};

//-------------------------------------------
MultiSelectViewModel.prototype.selectItem = function multiSelectViewModelSelectItem(element) {
    /// <summary>
    ///     Adds element to selection
    /// </summary>
    this.selectedItems.push(element);
    // remove filter
    this.filter("");
    // close list
    this.closeList();
};

//-------------------------------------------
MultiSelectViewModel.prototype.isCurrentItem = function multiSelectViewModelIsCurrentItem(element) {
    /// <summary>
    ///     Shows if specific element is set as current in selected
    /// </summary>
    if (!this.currentItem()) {
        return false;
    }

    return element === this.currentItem();
};

//-------------------------------------------
MultiSelectViewModel.prototype.isCurrentListItem = function multiSelectViewModelIsCurrentListItem(element) {
    /// <summary>
    ///     Shows if specific element is set as current in list
    /// </summary>
    if (this.currentListItemIndex() < 0) {
        return false;
    }

    return element === this.filteredItems()[this.currentListItemIndex()];
};

//-------------------------------------------
MultiSelectViewModel.prototype.setCurrentItem = function multiSelectViewModelSetCurrentItem(value, event) {
    /// <summary>
    ///     Sets current item
    /// </summary>
    this.currentItem(value);
    if (event) {
        event.stopPropagation();
    }
};

//-------------------------------------------
MultiSelectViewModel.prototype.setNextCurrentItem = function multiSelectViewModelSetNextCurrentItem() {
    /// <summary>
    ///     Sets current next element in selected list
    /// </summary>
    if ((this.filter() && this.filter().length > 0) || !this.selectedItems() || this.selectedItems().length === 0) {
        return;
    }

    if (this.currentItem()) { // if there is selection
        var index = ko.utils.arrayIndexOf(this.selectedItems(), this.currentItem());
        if (index > -1) {
            if (index < this.selectedItems().length - 1) { // if there are elements to the right
                this.currentItem(this.selectedItems()[index + 1]); // set next element current
            } else {
                this.currentItem(null); // otherwise - remove selection
                this._scrollToInput();
            }
        }
    }
};

//-------------------------------------------
MultiSelectViewModel.prototype.setPreviousCurrentItem = function multiSelectViewModelSetPreviousCurrentItem() {
    /// <summary>
    ///     Sets current previous element in selected list
    /// </summary>
    if (this.filter().length > 0 || !this.selectedItems() || this.selectedItems().length === 0) {
        return;
    }

    if (this.currentItem()) { // if there is selection
        var index = ko.utils.arrayIndexOf(this.selectedItems(), this.currentItem()); // select
        if (index > 0) { // there are items to the left
            this.currentItem(this.selectedItems()[index - 1]);
        }
    } else {
        this.currentItem(this.selectedItems()[this.selectedItems().length - 1]); // select last element
    }
};

//-------------------------------------------
MultiSelectViewModel.prototype._scrollToCurrentItem = function multiSelectViewModelScrollToCurrentItem(currentItem) {
    /// <summary>
    ///     Scrolls the current item into view if it is not in view
    /// </summary>
    if (currentItem) {
        ensureElementInView(this.$container().find('#item_' + currentItem.index));
    }
};

//-------------------------------------------
MultiSelectViewModel.prototype._scrollToInput = function multiSelectViewModelScrollToInput() {
    /// <summary>
    ///     Scrolls the input span into view if it is not in view
    /// </summary>
    ensureElementInView(this.$container().find('.ms-input'));
};

//-------------------------------------------
MultiSelectViewModel.prototype.setCurrentListItem = function multiSelectViewModelSetCurrentListItem(item) {
    /// <summary>
    ///     Sets current element in dropdown list
    /// </summary>

    if ((this._keypressed || 0) !== 0) {
        return;
    }

    if (this.filteredItems().length === 0 || !this.isListOpen()) {
        return;
    }

    var itemIndex = ko.utils.arrayIndexOf(this.filteredItems(), item);
    if (itemIndex >= 0) {
        this.currentListItemIndex(itemIndex); // set next element as current
    }
};

//-------------------------------------------
MultiSelectViewModel.prototype.setNextCurrentListItem = function multiSelectViewModelSetNextCurrentListItem() {
    /// <summary>
    ///     Sets next current element in dropdown list
    /// </summary>
    var count = this.filteredItems().length,
        currentIndex = this.currentListItemIndex();

    if (count === 0) {
        return;
    }

    if (!this.isListOpen()) {
        this.openList();
    } else {
        if (currentIndex < count - 1) { // if there are elements left below
            this.currentListItemIndex(currentIndex + 1); // set next element as current
        }
    }
};

//-------------------------------------------
MultiSelectViewModel.prototype.setNextPageCurrentListItem = function multiSelectViewModelSetNextPageCurrentListItem() {
    /// <summary>
    ///     Sets next N element as current element in dropdown list
    /// </summary>
    var count = this.filteredItems().length,
        currentIndex = this.currentListItemIndex();

    if (count === 0 || !this.isListOpen()) {
        return;
    }

    currentIndex = count - 1 < currentIndex + this._options.maxListSize ? count - 1 : currentIndex + this._options.maxListSize;
    this.currentListItemIndex(currentIndex); // set next page element as current
};

//-------------------------------------------
MultiSelectViewModel.prototype.setPreviousPageCurrentListItem = function multiSelectViewModelSetPreviousPageCurrentListItem() {
    /// <summary>
    ///     Sets previous N element as current element in dropdown list
    /// </summary>
    var count = this.filteredItems().length,
        currentIndex = this.currentListItemIndex();

    if (count === 0 || !this.isListOpen()) {
        return;
    }

    currentIndex = currentIndex - this._options.maxListSize < 0 ? 0 : currentIndex - this._options.maxListSize;
    this.currentListItemIndex(currentIndex); // set next page element as current
};

//-------------------------------------------
MultiSelectViewModel.prototype.setPreviousCurrentListItem = function multiSelectViewModelSetPreviousCurrentListItem() {
    /// <summary>
    ///     Sets previous current element in dropdown list
    /// </summary>
    var count = this.filteredItems().length,
        currentIndex = this.currentListItemIndex();

    if (count === 0) {
        return;
    }

    if (currentIndex > 0) { // if there are elements above
        this.currentListItemIndex(currentIndex - 1); // set next element current
    } else {
        this.closeList();
    }
};

//-------------------------------------------
MultiSelectViewModel.prototype.openList = function multiSelectViewModelOpenList() {
    /// <summary>
    ///     Opens dropdown list with items
    /// </summary>
    if (!this.state().isFailed && !this.state().isBusy && !this.isListOpen() && this.filteredItems().length > 0) {
        this.isListOpen(true);

        // select first element
        this.currentListItemIndex(0);
    }
};

//-------------------------------------------
MultiSelectViewModel.prototype.closeList = function multiSelectViewModelCloseList() {
    /// <summary>
    ///     Closes dropdown list with items
    /// </summary>
    if (this.isListOpen()) {
        this.isListOpen(false);
    }
};

//-------------------------------------------
MultiSelectViewModel.prototype.closeListAndUnselect = function multiSelectViewModelCloseListAndUnselect() {
    /// <summary>
    ///     Closes dropdown list with items  and unselects current
    /// </summary>
    this.closeList();
    this.currentItem(null);
};

//-------------------------------------------
MultiSelectViewModel.prototype.selectCurrentListItem = function multiSelectViewModelSelectCurrentListItem() {
    /// <summary>
    ///     Adds current item from dropdown list to selection
    /// </summary>
    if (this.isListOpen() && this.currentListItemIndex() >= 0) {
        this.selectItem(this.filteredItems()[this.currentListItemIndex()]);
        this.currentListItemIndex(-1);
    }
};

//-------------------------------------------
MultiSelectViewModel.prototype.removeLastSelectedElementIfEmptyFilter = function multiSelectViewModelRemoveLastSelectedElementIfEmptyFilter() {
    /// <summary>
    ///     Removes element, that is last in the list of selected items
    /// </summary>
    if (!this.selectedItems() || this.selectedItems().length === 0) {
        return;
    }

    if (!this.filter() || this.filter().length === 0) { // remove element only if filter is empty
        this.unSelectItem(this.selectedItems()[this.selectedItems().length - 1]);
    }
};

//-------------------------------------------
MultiSelectViewModel.prototype._getItemsByCategory = function multiSelectViewModelGetItemsByCategory(category) {
    /// <summary>
    ///     Gets all items from the list, that have same category
    /// </summary>
    return ko.utils.arrayFilter(this.items, function (item) {
        return item.categoryValue === category.value;
    });
};

//-------------------------------------------
MultiSelectViewModel.prototype._getItemByValue = function multiSelectViewModelGetItemByValue(value) {
    /// <summary>
    ///     Gets element from the list by value, case insensitive
    /// </summary>
    if (!value || value.length === 0) {
        return null;
    }
    value = value.toLowerCase();
    return ko.utils.arrayFirst(this.items, function (item) {
        return item.value && value === item.value.toLowerCase();
    });
};

//-------------------------------------------
MultiSelectViewModel.prototype.setSelectedItemsFromArray = function multiSelectViewModelSetSelectedItemsFromArray(selectItemsArray) {
    /// <summary>
    ///     Marks items from array as selected
    ///     Plain array of element values is expected
    /// </summary>
    var selectedItems = [];
    ko.utils.arrayForEach(selectItemsArray, function (selItem) {
        if (selItem) {
            var found = this._getItemByValue(selItem);

            if (found) {
                selectedItems.push(found);
            }
        }
    }.bind(this));

    this.selectedItems(selectedItems);
};

//-------------------------------------------
MultiSelectViewModel.prototype.selectItemsFromDialog = function multiSelectViewModelSelectItemsFromDialog(picklistValues) {
    /// <summary>
    ///     Selects items from pickList form dialog
    /// </summary>
    var found, selectedItems = [],
        errorItem = this.hasError() && this.selectedItems()[this.selectedItems().length - 1];

    if (picklistValues) {
        if (errorItem) {
            this.unSelectItem(errorItem);
        }

        if (Array.isArray(picklistValues) && picklistValues.length === 0) {
            // no results
            this.selectedItems(selectedItems);
        } else if (Array.isArray(picklistValues) && picklistValues.length > 0 &&
                (Array.isArray(picklistValues[0]) || typeof picklistValues[0] === "object")) {

            // multiple results
            ko.utils.arrayForEach(picklistValues, function (item) {
                found = this._getItemByValue(item[this._options.dataField]);
                if (found) {
                    selectedItems.push(found);
                }
            }.bind(this));

            this.selectedItems(selectedItems);
        } else {
            // on element selected
            found = this._getItemByValue(picklistValues[this._options.dataField]);
            if (found) {
                this.selectItem(found);
            }
        }

        if (errorItem) {
            this.selectItem(errorItem);
        }

        // focus element after dialog is closed
        this.focus();
    }
};

//-------------------------------------------
MultiSelectViewModel.prototype.focus = function multiSelectViewModelFocus(sender, event) {
    /// <summary>
    ///     Sets focus on element
    /// </summary>
    var targetClassname = event && (event.target || event.srcElement).className;

    // if clicked not left mouse button
    if (event && event.which !== 1) {
        return false;
    }

    this.isFocused(true);

    // If an item was not selected, scroll so the input box is in view
    if (targetClassname !== "ms-text" && targetClassname !== "ms-item") {
        this._scrollToInput();
    }

    // allow clicks through to reposition the cursor
    if (targetClassname === "ms-input") {
        return true;
    }

    return false;
};

//-------------------------------------------
MultiSelectViewModel.prototype.removeFocus = function multiSelectViewModelRemoveFocus() {
    /// <summary>
    ///     Removes focus from element
    /// </summary>
    this.isFocused(false);
};

//-------------------------------------------
MultiSelectViewModel.prototype.updateScrollTop = function multiSelectViewModelUpdateScrollTop() {
    /// <summary>
    ///     Changes scrolling position, depends on current selected item from in dropdown list
    /// </summary>
    var currentItemPosition = this.currentListItemIndex(), // current item position
        top = this.scrollTop() / this._options.listItemHeight, // top position
        bottom = top + this._options.maxListSize - 1; // bottom position

    if (currentItemPosition > bottom) {
        this.scrollTop((top + (currentItemPosition - bottom)) * this._options.listItemHeight);
    }

    if (currentItemPosition < top) {
        this.scrollTop(currentItemPosition * this._options.listItemHeight);
    }
};

//-------------------------------------------
MultiSelectViewModel.prototype.showDialog = function multiSelectViewModelShowDialog(sender, event) {
    /// <summary>
    ///     Shows pli form dialog
    /// </summary>
    this.closeList();

    var idField = this._options.dataField;
    pli.forms.registry.picklistForm.open({
        dataProvider: this.dataProvider,
        filterValue: null,
        value: this.selectItemsFromDialog,
        multiSelect: true,
        idField: idField,
        selectedItems: R.map(
            R.pipe(
                R.prop("value"), // extract 'value'
                R.partialRight(R.flip(R.assoc), [idField, {}]) // create new object { [idField]: value }
            ),
            this.allSelectedItems.peek()
        ),
        view: this._options.view || null,
        text: this._options.text || null
    });

    if (event) {
        event.stopPropagation();
    }
};

//-------------------------------------------
MultiSelectViewModel.prototype.autoComplete = function multiSelectViewModelAutoComplete() {
    /// <summary>
    ///     Autocompletes filter value or adds error item
    /// </summary>
    var item, result = false;

    // if filter is not empty
    if (this.filter().length > 0) {

        //  only one element left
        if (this.filteredItems().length === 1) {
            item = this.filteredItems()[0];
            result = true;
        }

        // if item was not found - add error item instead
        item = item || createMultiSelectItem(null, this.filter(), null, false, true, false, this.categoriesAndItems.length);

        // select found item or item with error
        this.selectItem(item);
    }
    return result;
};

//-------------------------------------------
MultiSelectViewModel.prototype.handleKeyUp = function multiSelectViewModelHandleKeyUp() {
    /// <summary>
    ///     Handles keyup event
    /// </summary>
    this._keypressed = false;
};

//-------------------------------------------
MultiSelectViewModel.prototype.handleKeyDown = function multiSelectViewModelHandleKeyDown(sender, event) {
    /// <summary>
    ///     Handles keydown event
    /// </summary>
    switch (event.which) {
    // up arrow
    case 38:
        this.setPreviousCurrentListItem();
        this._keypressed = true;
        event.preventDefault();
        break;
    // down arrow
    case 40:
        this.setNextCurrentListItem();
        this._keypressed = true;
        event.preventDefault();
        break;
    // home
    case 36:
        this.currentItem(this.selectedItems()[0]);
        event.stopPropagation();
        event.preventDefault();
        break;
    // end
    case 35:
        this.currentItem(null);
        break;
    // left arrow
    case 37:
        this.setPreviousCurrentItem();
        event.preventDefault();
        break;
    // right arrow
    case 39:
        this.setNextCurrentItem();
        event.preventDefault();
        break;
    // delete
    case 46:
        if (this.currentItem()) {
            var itemToDelete = this.currentItem();
            this.setNextCurrentItem();
            this.unSelectItem(itemToDelete);
            event.stopPropagation();
            event.preventDefault();
        }
        break;
    // Escape
    case 27:
        this.closeListAndUnselect();
        break;
    // Enter
    case 13:
        this.selectCurrentListItem();
        event.preventDefault();
        break;
    // Backspace
    case 8:
        this.removeLastSelectedElementIfEmptyFilter();
        break;
    // tab
    case 9:
        if (!event.shiftKey && this.filter().length > 0) {
            if (this.autoComplete()) {
                event.preventDefault();
            }
        }
        break;
    // pagedown
    case 34:
        this.setNextPageCurrentListItem();
        this._keypressed = true;
        break;
    // pageup
    case 33:
        this.setPreviousPageCurrentListItem();
        this._keypressed = true;
        break;
    // F3
    case 114:
        this.showDialog();
        break;
    }
    return true;
};

//-------------------------------------------
MultiSelectViewModel.prototype.updateListPosition = function multiSelectViewModelUpdateListPosition() {
    /// <summary>
    ///     Updates dropdown list position
    /// </summary>
    this.isListOpen.valueHasMutated();
};



//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
// "MultiselectBehaviour" class
//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~

//-------------------------------------------
// Behaviour for a multi-select pick-list.
function MultiselectBehaviour() {
    this.defer = true;
}

//-------------------------------------------
MultiselectBehaviour.prototype.dispose = function picklistBehaviourDispose() {
    if (this._disposables) {
        this._disposables.dispose();
    }
};

//-------------------------------------------
MultiselectBehaviour.prototype.init = function picklistBehaviourInit() {
    // state is not defined by observablePliTextBox any more, bring it back until multiselect is refactored to use "pliTextBox" binding
    this.state = ko.observable({
        isBusy: false,
        isFailed: false,
        isValid: true,
        message: null
    });

    // options
    this.options = R.merge({
        textField: 0,       // name or number of the field, used to show text of the item
        dataField: 0,       // name or number of the field, used to unique identify the item
        category: null,     // name of the group of the pickList, used to create categories
        maxListSize: 8,     // number of elements in the dropdown list
        listItemHeight: 22, // height of the one item in the dropdown list
        initialCategories: null, // initial categories
        dropdownWidth: null, // dropdown width, if null equals the with of the input
        // delays
        updateDropdownPositionAfterFocusDelay : 160,
        closeListDelay : 150,
        updateListPositionAfterFilterTextChangedDelay : 10

    }, this.behaviourData || {});

    // internal update values
    this._updateValues = MultiselectBehaviour.prototype._updateValues.bind(this);

    this._dataProvider = getDataProvider(this);

    // "multiSelectViewModel" must be initialized for
    // pliMultiselect "init" binding to succeed; "items"
    // and "categories" will be updated when the data from
    // the data-provider is available
    this.multiSelectViewModel = new MultiSelectViewModel(
        [], // items
        [], // categories
        this.options,
        this
    );

    this._disposables = new CompositeDisposable(
        this._dataProvider,
        // subscribe to data provider changes
        this._dataProvider.search(Rx.Observable.of({}), QueryOrigin.Initial).subscribe(MultiselectBehaviour.prototype._onDataChanged.bind(this)),
        // subscribe to main observable changes
        this.subscribe(MultiselectBehaviour.prototype._onObservableChanged, this)
    );
};

//-------------------------------------------
MultiselectBehaviour.prototype.validate = function multiselectBehaviourValidate() {
    return (this.multiSelectViewModel && !this.multiSelectViewModel.hasError()
        ? null
        : MultiselectBehaviour.prototype._getErrorMessage);
};

//-------------------------------------------
MultiselectBehaviour.prototype._getErrorMessage = pliObservable.shared.createGetErrorMessage("errorInvalidValue", "Invalid value");

//-------------------------------------------
// Parses data from pickList observable.
//
// Expects "this" to be a observable array.
MultiselectBehaviour.prototype._parseData = function multiselectBehaviourParseData(pickListData) {
    var o = this,
        i,
        item,
        categories = [],
        items = [],
        text,
        value,
        groupValue,
        categoriesItems;

    if (pickListData.data) {
        if (o.options.category && o.options.category.length && pickListData.data.groups[o.options.category]) {
            for (i = 0; i < pickListData.data.groups[o.options.category].length; i += 1) {
                item = pickListData.data.groups[o.options.category][i];
                value = item.name === "(Empty)" ? null : item.name;
                categories.push(createMultiSelectItem(value, item.name, null, true, false, false, (pickListData.data.groups[o.options.category].length - i) * -1));
            }
        }

        // parse items
        for (i = 0; i < pickListData.data.items.length; i += 1) {
            item = pickListData.data.items[i];
            text = item[o.options.textField];
            value = item[o.options.dataField];
            groupValue = null;

            // get item category
            if (o.options.category && o.options.category.length) {
                groupValue = item[o.options.category];
            }

            items.push(createMultiSelectItem(value, text, groupValue, false, false, false, i));
        }
    }

    // child view model
    if (!o.multiSelectViewModel) {
        o.multiSelectViewModel = new MultiSelectViewModel(items, categories, o.options, o);
    } else {
        o.multiSelectViewModel.updateItemsAndCategories(items, categories);
    }

    // set initial categories
    if (categories.length > 0 && Array.isArray(o.options.initialCategories) && o.options.initialCategories.length > 0) {
        categoriesItems = ko.utils.arrayFilter(categories, function (category) {
            return ko.utils.arrayIndexOf(o.options.initialCategories, category.value) >= 0;
        });
        o.multiSelectViewModel.selectedItems.push.apply(o.multiSelectViewModel.selectedItems, categoriesItems);
    }
};

//-------------------------------------------
// Handle update of the root observable.
// Updates child viewModel selectedItems
//
// Expects "this" to be picklist observable.
MultiselectBehaviour.prototype._onObservableChanged = function multiselectBehaviourOnObservableChanged(values) {
    var o = this;
    if (o._isChildViewUpdate) {
        return;
    }

    if (values === null) { values = []; }
    if (!Array.isArray(values)) { throw new Error("Multiselect observable value can only be an array or null"); }
    o.multiSelectViewModel.setSelectedItemsFromArray(values); // update values of child viewModel
};

//-------------------------------------------
// Handle update of the selectedItems of
// child viewModel.
//
// Expects "this" to be picklist observable.
MultiselectBehaviour.prototype._updateValues = function multiselectBehaviourUpdateValues(values) {
    var o = this,
        pliValues = [];

    if (values && values.length >= 0) {
        pliValues = ko.utils.arrayMap(values, function (item) {
            return item.value;
        });
    }

    // to prevent double update
    o._isChildViewUpdate = true;
    if (pliValues.length > 0) {
        o.load(pliValues);
    } else {
        o.load(null);
    }
    o._isChildViewUpdate = false;
};

//-------------------------------------------
// Update the state based on the changes to
// the data.  Parse the value if the data
// has been loaded.
//
// Expects "this" to be picklist observable.
MultiselectBehaviour.prototype._onDataChanged = function multiselectBehaviourOnDataChanged(value) {
    // reset the state.
    var state = this.state.peek();
    state.isValid = true;
    state.isFailed = false;
    state.isBusy = false;

    if (value && value.data) { // data load succeeded (parse value)
        MultiselectBehaviour.prototype._parseData.call(this, value);
        this.valueHasMutated();
    } else if (value && value.error) { // data load failed
        state.isFailed = true;
    } else { // data load in progress
        state.isBusy = true;
    }

    this.state.valueHasMutated();
};


//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
// Public
//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~

//-------------------------------------------
module.exports = new MultiselectBehaviour();




//////////////////
// WEBPACK FOOTER
// ./~/pli/forms-knockoutcontrols-multiselect/knockoutControlsMultiSelector.js
// module id = 445
// module chunks = 49